import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=06b1652a&scoped=true"
import script from "./activityList.vue?vue&type=script&lang=js"
export * from "./activityList.vue?vue&type=script&lang=js"
import style0 from "./activityList.vue?vue&type=style&index=0&id=06b1652a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1652a",
  null
  
)

export default component.exports